import { store } from 'src/app/store';
import { appApiSlice } from 'src/api/app-ApiSlice';
import {
  TAG_FLOOR_ROOMS_AND_RELATED,
  TAG_FLOOR_VIEW_PRODUCTS,
  TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS,
  TAG_GET_QUOTE,
  TAG_PINOUT_DEVICES,
  TAG_PROJECT_QUOTE_DATA,
  TAG_PROJECT_TREE
} from 'src/api/api-tags';

export function refreshFloorView() {
  store.dispatch(appApiSlice.util.invalidateTags([{ type: TAG_FLOOR_VIEW_PRODUCTS }]));
}

export function invalidatePlannerDerivedData() {
  store.dispatch(appApiSlice.util.invalidateTags([
    { type: TAG_FLOOR_ROOMS_AND_RELATED },
    { type: TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS },
    { type: TAG_PROJECT_TREE },
    { type: TAG_PROJECT_QUOTE_DATA },
    { type: TAG_GET_QUOTE },
    { type: TAG_PINOUT_DEVICES },
  ]));
}
